import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_fb7a1e04 from 'nuxt_plugin_bootstrapvue_fb7a1e04' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_index_7d657e9f from 'nuxt_plugin_index_7d657e9f' // Source: ./firebase/index.js (mode: 'all')
import nuxt_plugin_nuxtleaflet_30026816 from 'nuxt_plugin_nuxtleaflet_30026816' // Source: ./nuxt-leaflet.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_38c77377 from 'nuxt_plugin_cookieuniversalnuxt_38c77377' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_toast_bd34c304 from 'nuxt_plugin_toast_bd34c304' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_moment_3fbf0cae from 'nuxt_plugin_moment_3fbf0cae' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_axios_55955c62 from 'nuxt_plugin_axios_55955c62' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_string_64887d90 from 'nuxt_plugin_string_64887d90' // Source: ../plugins/string.js (mode: 'all')
import nuxt_plugin_scripts_583b33e5 from 'nuxt_plugin_scripts_583b33e5' // Source: ../plugins/scripts.js (mode: 'all')
import nuxt_plugin_eventhub_294a4a74 from 'nuxt_plugin_eventhub_294a4a74' // Source: ../plugins/eventhub.js (mode: 'all')
import nuxt_plugin_cookie_7d4b4e5d from 'nuxt_plugin_cookie_7d4b4e5d' // Source: ../plugins/cookie.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../plugins/auth.js (mode: 'all')
import nuxt_plugin_xdata_0aadffea from 'nuxt_plugin_xdata_0aadffea' // Source: ../plugins/xdata.js (mode: 'all')
import nuxt_plugin_env_6ad7ce40 from 'nuxt_plugin_env_6ad7ce40' // Source: ../plugins/env.js (mode: 'all')
import nuxt_plugin_charts_63c1ba68 from 'nuxt_plugin_charts_63c1ba68' // Source: ../plugins/charts.js (mode: 'all')
import nuxt_plugin_components_50cb0b6b from 'nuxt_plugin_components_50cb0b6b' // Source: ../plugins/components.js (mode: 'all')
import nuxt_plugin_http_30dfb839 from 'nuxt_plugin_http_30dfb839' // Source: ../plugins/http.js (mode: 'all')
import nuxt_plugin_swipe_246c841a from 'nuxt_plugin_swipe_246c841a' // Source: ../plugins/swipe.js (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_file_984f9276 from 'nuxt_plugin_file_984f9276' // Source: ../plugins/file.js (mode: 'all')
import nuxt_plugin_config_3fddc0bf from 'nuxt_plugin_config_3fddc0bf' // Source: ../plugins/config.js (mode: 'all')
import nuxt_plugin_mask_18e26f55 from 'nuxt_plugin_mask_18e26f55' // Source: ../plugins/mask.js (mode: 'all')
import nuxt_plugin_object_170743a2 from 'nuxt_plugin_object_170743a2' // Source: ../plugins/object.js (mode: 'all')
import nuxt_plugin_inicis_43fef038 from 'nuxt_plugin_inicis_43fef038' // Source: ../plugins/inicis.js (mode: 'all')
import nuxt_plugin_validate_709b3feb from 'nuxt_plugin_validate_709b3feb' // Source: ../plugins/validate.js (mode: 'all')
import nuxt_plugin_modal_640f2cc0 from 'nuxt_plugin_modal_640f2cc0' // Source: ../plugins/modal.js (mode: 'all')
import nuxt_plugin_filter_3b4804c9 from 'nuxt_plugin_filter_3b4804c9' // Source: ../plugins/filter.js (mode: 'all')
import nuxt_plugin_sortable_60ca49c9 from 'nuxt_plugin_sortable_60ca49c9' // Source: ../plugins/sortable.js (mode: 'all')
import nuxt_plugin_themecore_4ae3b384 from 'nuxt_plugin_themecore_4ae3b384' // Source: ../plugins/theme-core.js (mode: 'all')
import nuxt_plugin_theme_352fc904 from 'nuxt_plugin_theme_352fc904' // Source: ../plugins/theme.js (mode: 'all')
import nuxt_plugin_address_4b6c2d0e from 'nuxt_plugin_address_4b6c2d0e' // Source: ../plugins/address.js (mode: 'all')
import nuxt_plugin_toast_bdf93834 from 'nuxt_plugin_toast_bdf93834' // Source: ../plugins/toast.js (mode: 'all')
import nuxt_plugin_plugin_96b4f06a from 'nuxt_plugin_plugin_96b4f06a' // Source: ./auth/plugin.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = !!err
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_fb7a1e04 === 'function') await nuxt_plugin_bootstrapvue_fb7a1e04(app.context, inject)
  if (typeof nuxt_plugin_index_7d657e9f === 'function') await nuxt_plugin_index_7d657e9f(app.context, inject)
  if (typeof nuxt_plugin_cookieuniversalnuxt_38c77377 === 'function') await nuxt_plugin_cookieuniversalnuxt_38c77377(app.context, inject)
  if (typeof nuxt_plugin_moment_3fbf0cae === 'function') await nuxt_plugin_moment_3fbf0cae(app.context, inject)
  if (typeof nuxt_plugin_axios_55955c62 === 'function') await nuxt_plugin_axios_55955c62(app.context, inject)
  if (typeof nuxt_plugin_string_64887d90 === 'function') await nuxt_plugin_string_64887d90(app.context, inject)
  if (typeof nuxt_plugin_scripts_583b33e5 === 'function') await nuxt_plugin_scripts_583b33e5(app.context, inject)
  if (typeof nuxt_plugin_eventhub_294a4a74 === 'function') await nuxt_plugin_eventhub_294a4a74(app.context, inject)
  if (typeof nuxt_plugin_cookie_7d4b4e5d === 'function') await nuxt_plugin_cookie_7d4b4e5d(app.context, inject)
  if (typeof nuxt_plugin_auth_7f7561ce === 'function') await nuxt_plugin_auth_7f7561ce(app.context, inject)
  if (typeof nuxt_plugin_xdata_0aadffea === 'function') await nuxt_plugin_xdata_0aadffea(app.context, inject)
  if (typeof nuxt_plugin_env_6ad7ce40 === 'function') await nuxt_plugin_env_6ad7ce40(app.context, inject)
  if (typeof nuxt_plugin_charts_63c1ba68 === 'function') await nuxt_plugin_charts_63c1ba68(app.context, inject)
  if (typeof nuxt_plugin_components_50cb0b6b === 'function') await nuxt_plugin_components_50cb0b6b(app.context, inject)
  if (typeof nuxt_plugin_http_30dfb839 === 'function') await nuxt_plugin_http_30dfb839(app.context, inject)
  if (typeof nuxt_plugin_swipe_246c841a === 'function') await nuxt_plugin_swipe_246c841a(app.context, inject)
  if (typeof nuxt_plugin_i18n_1fba523a === 'function') await nuxt_plugin_i18n_1fba523a(app.context, inject)
  if (typeof nuxt_plugin_file_984f9276 === 'function') await nuxt_plugin_file_984f9276(app.context, inject)
  if (typeof nuxt_plugin_config_3fddc0bf === 'function') await nuxt_plugin_config_3fddc0bf(app.context, inject)
  if (typeof nuxt_plugin_mask_18e26f55 === 'function') await nuxt_plugin_mask_18e26f55(app.context, inject)
  if (typeof nuxt_plugin_object_170743a2 === 'function') await nuxt_plugin_object_170743a2(app.context, inject)
  if (typeof nuxt_plugin_inicis_43fef038 === 'function') await nuxt_plugin_inicis_43fef038(app.context, inject)
  if (typeof nuxt_plugin_validate_709b3feb === 'function') await nuxt_plugin_validate_709b3feb(app.context, inject)
  if (typeof nuxt_plugin_modal_640f2cc0 === 'function') await nuxt_plugin_modal_640f2cc0(app.context, inject)
  if (typeof nuxt_plugin_filter_3b4804c9 === 'function') await nuxt_plugin_filter_3b4804c9(app.context, inject)
  if (typeof nuxt_plugin_sortable_60ca49c9 === 'function') await nuxt_plugin_sortable_60ca49c9(app.context, inject)
  if (typeof nuxt_plugin_themecore_4ae3b384 === 'function') await nuxt_plugin_themecore_4ae3b384(app.context, inject)
  if (typeof nuxt_plugin_theme_352fc904 === 'function') await nuxt_plugin_theme_352fc904(app.context, inject)
  if (typeof nuxt_plugin_address_4b6c2d0e === 'function') await nuxt_plugin_address_4b6c2d0e(app.context, inject)
  if (typeof nuxt_plugin_toast_bdf93834 === 'function') await nuxt_plugin_toast_bdf93834(app.context, inject)
  if (typeof nuxt_plugin_plugin_96b4f06a === 'function') await nuxt_plugin_plugin_96b4f06a(app.context, inject)

  if (process.client) {
    if (typeof nuxt_plugin_nuxtleaflet_30026816 === 'function') await nuxt_plugin_nuxtleaflet_30026816(app.context, inject)
    if (typeof nuxt_plugin_toast_bd34c304 === 'function') await nuxt_plugin_toast_bd34c304(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
